import cn from 'classnames'
import React, { useEffect, useState } from 'react'

import styles from './stories.module.scss'

const isSocialMediaDisabled = true

const waitForIframe = (cb: (iFrameLoaded: boolean) => void) => () => {
  const iframe = window.document.querySelector('.embedsocial-iframe-gallery') as HTMLIFrameElement
  if (iframe) {
    iframe.onload = () => setTimeout(() => cb(true), 100)
  } else {
    setTimeout(waitForIframe, 100)
  }
}

export default function Stories({ variant = 'brand' }: { variant?: 'brand' | 'free' }) {
  const [iFrameLoaded, setIframeLoaded] = useState(false)
  useEffect(() => {
    const id = 'embed-social-stories'
    if (!window.document.getElementById(id)) {
      const s = window.document.createElement('script')
      s.id = id
      s.async = true
      s.src = 'https://embedsocial.com/embedscript/stg.js'
      s.onload = waitForIframe(setIframeLoaded)
      window.document.head.appendChild(s)
    } else {
      setIframeLoaded(true)
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const _ = (window as any).EMBEDSOCIALSTORYGALLERY

    if (_) {
      const embedsocialStoryGallery = window.document.getElementsByClassName('embedsocial-story-gallery')
      for (let i = 0; i < embedsocialStoryGallery.length; i++) {
        const embedsocialStoryGalleryRef = embedsocialStoryGallery[i].getAttribute('data-ref')
        _.getEmbedData(embedsocialStoryGalleryRef, embedsocialStoryGallery[i])
      }
    }
  }, [])

  if (isSocialMediaDisabled) {
    return null
  }

  return (
    <div
      className={cn(
        styles.root,
        variant === 'free' && styles.free,
        iFrameLoaded && styles.loaded,
        'embedsocial-story-gallery'
      )}
      data-ref="1ecb32b1d05e685de30a9a652853d145851519f3"
      id="embedsocial-story-gallery"
    />
  )
}
